import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminOrganizationsPage from "@/pages/admin/AdminOrganizationsPage";

export const Route = createFileRoute("/_admin/admin/organizations")({
  head: () => pageHead("Admin · Organizations & Staff Roles", "AKIVA admin · internal organizations and staff roles.", "/admin/organizations", true),
  component: AdminOrganizationsPage,
});
